// Floor-resolution router for the "+ New Room" dialog.
//
// PowerSync builds run fully offline, where POST /capture/floors/resolve
// is unreachable. When the PowerSync capture adapter is active the dialog
// must resolve the chosen floor name against the local SQLite mirror
// (find-or-create a per-building floors row on-device); otherwise it uses
// the REST endpoint. Both paths return the same ResolvedFloor, so the
// dialog consumes whichever the build selects without branching.
//
// Lives outside the dialog component so the routing decision is unit
// testable without rendering React or pulling in the dialog's import
// graph — the offline-vs-online selection is the core of the offline
// room-creation fix and is worth protecting directly. Mirrors the
// default-asset-type-search.ts seam.

import {
  resolveFloorOption,
  type ResolvedFloor,
} from '../../hooks/use-floor-options'
import { resolveFloorLocal } from '../../hooks/powersync/resolve-floor-local'
import { POWERSYNC_CAPTURE_CLIENT_ENABLED } from '../client/capture-client-factory'

export function resolveFloor(
  sessionId: string,
  floorName: string,
): Promise<ResolvedFloor> {
  if (POWERSYNC_CAPTURE_CLIENT_ENABLED) {
    return resolveFloorLocal(sessionId, floorName)
  }
  return resolveFloorOption(sessionId, floorName)
}
